/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Model_StandardInputs */

const en_landing_studio_model_standard = /** @type {(inputs: Landing_Studio_Model_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5`)
};

const zh_landing_studio_model_standard = /** @type {(inputs: Landing_Studio_Model_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5`)
};

/**
* | output |
* | --- |
* | "Ideogram 4.5" |
*
* @param {Landing_Studio_Model_StandardInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_model_standard = /** @type {((inputs?: Landing_Studio_Model_StandardInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Model_StandardInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_model_standard(inputs)
	return zh_landing_studio_model_standard(inputs)
});
export { landing_studio_model_standard as "landing.studio.model_standard" }